import { render, staticRenderFns } from "./TextInputComponent.vue?vue&type=template&id=456601b6"
import script from "./TextInputComponent.vue?vue&type=script&lang=js"
export * from "./TextInputComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports